import { z } from 'zod';
import { AdHocInvoiceLineItemSchema, DocumentTaxTypeSchema, RegistryLinkedInvoiceLineItemSchema, } from './invoices.js';
import { EndConditionSchema, RecurrenceFrequencySchema } from './recurrence.js';
/** Line item for a recurring invoice — same union as invoice line items. */
export const CreateRecurringInvoiceLineItemSchema = z.union([
    RegistryLinkedInvoiceLineItemSchema,
    AdHocInvoiceLineItemSchema,
]);
/** Request body for creating a recurring invoice. */
export const CreateRecurringInvoiceSchema = z.object({
    clientId: z.string().min(1, { error: 'Client is required' }),
    frequency: RecurrenceFrequencySchema,
    interval: z.number().int().min(1).default(1),
    daysOfWeek: z.array(z.number().int().min(0).max(6)).default([]),
    dayOfMonth: z.number().int().min(1).max(31).optional(),
    monthOfYear: z.number().int().min(1).max(12).optional(),
    endCondition: EndConditionSchema,
    nextRunAt: z.string().datetime({ message: 'nextRunAt must be an ISO datetime string' }),
    locale: z.literal('en-AU').optional(),
    currency: z.literal('AUD').optional(),
    taxType: DocumentTaxTypeSchema.default('NONE'),
    taxRate: z.coerce.number().min(0).max(1).default(0),
    netDays: z.number().int().min(0).default(14),
    notes: z
        .string()
        .transform((val) => (val === '' ? null : val))
        .pipe(z.string().nullable())
        .default(null),
    autoSend: z.boolean().default(false),
    remindersEnabled: z.boolean().optional(),
    /**
     * The picked reminder schedule; null or omitted uses the client's own, else the
     * default.
     */
    reminderScheduleId: z.string().min(1).nullable().optional(),
    lineItems: z.array(CreateRecurringInvoiceLineItemSchema).default([]),
});
/**
 * Request body for updating a recurring invoice. clientId and status are not updatable
 * via this endpoint.
 */
export const UpdateRecurringInvoiceSchema = CreateRecurringInvoiceSchema.omit({
    clientId: true,
    lineItems: true,
}).partial();
/** Valid status values for state-machine transition requests. */
export const RecurringInvoiceStatusSchema = z.enum(['ACTIVE', 'PAUSED', 'CANCELLED']);
/** Request body for transitioning a recurring invoice's status. */
export const UpdateRecurringInvoiceStatusSchema = z.object({
    status: RecurringInvoiceStatusSchema,
});
//# sourceMappingURL=recurring-invoices.js.map